module.exports = __webpack_public_path__ + "img/YINGLIAN.a868a971.png";